module.exports = __webpack_public_path__ + "img/status4.4de476bf.png";